import { interpolateFps, type BenchmarkData } from '../lib/fps-interpolation';

class GamingFpsSummary extends HTMLElement {
  connectedCallback() {
    const configScript = this.querySelector('[data-fps-summary-config]');
    const benchmarkScript = this.querySelector('[data-fps-benchmarks]');
    if (!configScript?.textContent || !benchmarkScript?.textContent) return;

    try {
      const config = JSON.parse(configScript.textContent);
      const benchmarks: BenchmarkData = JSON.parse(benchmarkScript.textContent);

      const fps = interpolateFps(
        benchmarks,
        config.defaultGame,
        config.passmarkScore,
        config.defaultResolution,
        config.defaultGraphics,
      );

      const el = this.querySelector('[data-fps-summary]');
      if (el && fps > 0) {
        const res = config.defaultResolution === '4k' ? '4K' : config.defaultResolution;
        const gfx = config.defaultGraphics.charAt(0).toUpperCase() + config.defaultGraphics.slice(1);
        el.textContent = `${fps}+ (${config.defaultGameName}, ${res}, ${gfx})`;
      }
    } catch {
      /* ignore parse errors */
    }
  }
}

if (!customElements.get('gaming-fps-summary')) {
  customElements.define('gaming-fps-summary', GamingFpsSummary);
}
